import { Link } from "@tanstack/react-router"
import type { User } from "@apps/gwservice/types"
import { Card } from "~/components/ui/card"
import { RemoteImg } from "~/components/ui/remote-img"

interface Props {
  user: User
}

export function MemberCard({ user }: Props) {
  return (
    <Link to={"/user/" + user.id} className="block w-full">
      <Card className="flex flex-row p-0! w-full h-member-card">
        <div className="relative w-group-img h-member-card shrink-0">
          {user.avatar?.url ? (
            <RemoteImg src={user.avatar.url} alt={user.name || "пользователь"} className="object-cover size-full" />
          ) : (
            <div className="w-full h-full bg-muted" />
          )}
        </div>
        <div className="flex-1 px-m py-s flex flex-col gap-xs min-w-0">
          <div className="text-base truncate" lang="ru">{user.name}</div>
          {user.company && (
            <div className="text-sm text-secondary-foreground truncate" lang="ru">{user.company}</div>
          )}
          {user.position && (
            <div className="text-sm text-muted-foreground truncate" lang="ru">{user.position}</div>
          )}
        </div>
      </Card>
    </Link>
  )
}
